
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { RegistrationForm } from "@/components/auth/RegistrationForm"
import { useToast } from "@/hooks/use-toast"

export default function NewUser() {
  const { toast } = useToast()
  const navigate = useNavigate()
  
  const onSuccess = () => {
    toast({
      title: "Usuário criado com sucesso",
      description: "O novo usuário foi adicionado ao sistema.",
    })
    navigate("/users")
  }
  
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container max-w-5xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6">Novo Usuário</h1>
        <RegistrationForm onSuccessCallback={onSuccess} adminCreating={true} />
      </div>
    </div>
  )
}
